
    import {Component, Prop, Vue} from 'vue-property-decorator';
    import {Question} from "../lib/Question";
    import Response from "../lib/Response";

    @Component({})
    export default class ImageUploadQuestion extends Vue {
        @Prop()
        public question: Question;

        private allowedPictureType = ['image/png', 'image/jpg', 'image/jpeg', 'image/gif'];
        private text = 'cliquer pour selectionner une photo';
        private state = null;
        private link = null;
        private isUploading = false;
        private next_slice = null;
        private startChunk = 0;
        private slice_size = 1024 * 1024 * 2;
        private currentFile = null;
        private count = 0;
        private percent = 0;
        private currentXhr = null;
        private xhrTable = [];
        private fileArray = [];
        private file_sha1 = null;
        private full = 0;
        private currentId = null;
        private folder;
        public uploadEndPoint = process.env.VUE_APP_BACKEND_URL + 'api/uploader';
        private assetBase = process.env.VUE_APP_CLOUD_REAL_STORAGE_URL;
        private error = null;
        private target = null;
        private response;

        public mounted(){
            if(this.question.currentResponse){
                this.link = 'url(' + this.question.currentResponse.value + ') no-repeat center/cover';
                if(this.question.currentResponse.value.trim() !== ''){
                    this.text = '';
                }
            }
        }
        async upload(e) {
            this.state = '';
            if (e.target.files.length > 0) {
                this.isUploading = true;
                e.target.setAttribute('disabled', 'disabled');
            }
            this.target = e.target;
            const file = e.target.files[0];
            var coolSize = Math.ceil((file.size / 1024) / 1024);
            var sizeUnit = 'o';
            if (coolSize < 1) {
                sizeUnit = 'o';
            } else if (coolSize < 1000) {
                sizeUnit = 'Mo';
            } else {
                sizeUnit = 'Go';
            }
            if (!this.isAllowedType(file)) {
                this.isUploading = false;
                e.target.removeAttribute('disabled');
                this.text = 'Veuillez selectionnez une image';
                this.state = 'bad';
            }

            var reader = new FileReader();
            reader.addEventListener('load', (e) => {
                this.link = 'url(' + reader.result + ') no-repeat center/cover';
                this.text = null;
            });
            reader.readAsDataURL(file);
            this.fileArray.push(file);
            await this.generateId();
            this.uploadBlob();
            // console.log(this.uploadEndPoint);
        }


        async generateId() {
            var number = Math.random();
            number.toString(36);
            this.currentId = number.toString(36).substr(2, 9);
            this.folder = this.$store.state.currentResponseGroup.id;
        }

        async nextFile() {
            this.fileArray.shift();
            this.startChunk = 0;
            if (this.fileArray.length === 0) {
                this.state = 'good';
                this.isUploading = false;
                this.abort();
                return;
            }
            await this.generateId();
            this.uploadBlob();
        }

        abort() {
            this.fileArray = [];
            this.startChunk = 0;
            this.isUploading = false;
            if (this.currentXhr) {
                this.currentXhr.abort();
            }
            this.target.removeAttribute('disabled');
        }

        saveAnswerLink(link) {
            this.question.currentResponse.value = link;
            this.question.changedEvent.emit("");
            this.question.validate();
        }

        uploadBlob() {
            let file = this.fileArray[0];
            this.count = Math.ceil(file.size / this.slice_size);
            var next_slice = this.startChunk + this.slice_size;
            if (next_slice > file.size) next_slice = file.size;
            var blob = file.slice(this.startChunk, next_slice);

            console.log('de ' + this.startChunk + ' a ' + next_slice);
            var reader = new FileReader;
            reader.onloadend = (ev) => {
                if (ev.target.readyState !== FileReader.DONE) {
                    return null;
                }
                var formData = new FormData();
                formData.append('loaded', this.count);
                formData.append('fileSha1', this.currentId);
                formData.append('fileName', file.name);
                formData.append('fileSize', file.size);
                formData.append('fileType', file.type);
                formData.append('uniqId', this.folder);
                formData.append('file', ev.target.result);
                this.currentXhr = new XMLHttpRequest();

                var xhr = this.currentXhr;

                xhr.onreadystatechange = () => {
                    if (xhr.readyState === 4) {
                        if (xhr.status === 200 && xhr.responseText !== '') {
                            var json = JSON.parse(xhr.response);
                            if (json.hasOwnProperty('success') && json.hasOwnProperty('status')) {
                                this.percent = Math.floor((this.count * 100) / Math.ceil(file.size / this.slice_size));
                                if (json.success && json.status === 'finished') {
                                    console.log(this.assetBase + json.file.cloudLink);
                                    this.link = 'url(' + this.assetBase + json.file.cloudLink + ') no-repeat center/cover';
                                    this.saveAnswerLink(this.assetBase + json.file.cloudLink);
                                    this.nextFile();
                                }
                                if (json.success && json.status === 'loaded') {
                                    this.count = json.received + 1;
                                    // console.log(this.count);
                                    this.startChunk = this.count * this.slice_size;
                                    this.uploadBlob();
                                }
                                if (json.success && json.status === 'missing') {
                                    this.count = json.received;
                                    // console.log(this.count);
                                    this.startChunk = this.count * this.slice_size;
                                    this.uploadBlob()
                                }
                            }
                        } else if (xhr.readyState == 4 && xhr.status !== 200) {
                            console.log(xhr.response);
                            this.abort();
                            this.text = 'Une erreur a été rencontrée lors du téléchargement du fichier';
                        }
                    }
                };
                xhr.open("POST", this.uploadEndPoint);
                xhr.send(formData);
            }
            reader.readAsDataURL(blob);

        }


        isAllowedType(file) {
            if (this.allowedPictureType.indexOf(file.type) === -1) {
                return false;
            }
            return true;
        }
    }
